<!-- eslint-disable max-len -->
<ion-content class="ion-padding">
  <div class="logo-container">
    <div class="logo">
      <img src="/assets/imgs/logo.png" alt="logo" />
    </div>
  </div>

  <div class="content-card" [ngClass]="{'content-card-center': isSubmitted() || isNotAvailable() || isLoading()}">
    <div class="">
      @if (isLoading()) {
      <div class="loading-container">
        <ion-spinner></ion-spinner>
      </div>
      } @if (!isLoading() && !isNotAvailable() && !isSubmitted()) {
      <div class="form-container">
        <div class="vacancy-header">
          <h1 class="vacancy-header__title">{{ profileName() }}</h1>
          @if (introText()) {
          <p class="vacancy-header__subtitle" [innerHTML]="introText()"></p>
          }
        </div>

        <div *ngIf="vacancyFiles() as vfiles" class="form-field">
          <pa-data-list [data]="vfiles" />
        </div>

        <form class="form-content" [formGroup]="form" (ngSubmit)="onSubmit()">

          @if (pvzs().length > 0) {
          <div class="pvz-container">
            <pa-multi-select
              [options]="pvzs()"
              label="Доступные для работы ПВЗ"
              placeholder="Выберите удобные вам ПВЗ..."
              [customErrorMessages]="{ required: 'Выберите пункты выдачи, на которых вы готовы работать.' }"
              formControlName="pvzs"
            >
            </pa-multi-select>
          </div>
          } @for (field of formFields(); track field.name) {
          <div class="form-field">
            @if (field.name === 'telegram') {
              <pa-input [label]="field.label" [formControlName]="field.name" [tooltip]="'Публичное имя пользователя'"> </pa-input>
            } @else {
              @switch (field.type) { 
                @case ('String') {
                  <pa-input
                    [maxLength]="200"
                    [label]="field.label"
                    [formControlName]="field.name"
                  >
                  </pa-input>
                } @case ('Number') {
                  <pa-input [label]="field.label" [inputmode]="'decimal'" [type]="'number'" [formControlName]="field.name"> </pa-input>
                } @case ('PhoneNumber') {
                  <pa-input-phone [formControlName]="field.name" [label]="field.label" />
                } @case ('Boolean') {
                  <div class="checkbox-field">
                    <p-checkbox [formControlName]="field.name" [binary]="true" [inputId]="'input-' + field.name" />
                    <label [for]="'input-' + field.name" class="ml-2"> {{ field.label }} </label>
                  </div>
                } @case ('File') {
                  <pa-uploadfile [formControlName]="field.name" [isAuthorized]="false" [uuid]="currentUuid" [label]="field.label" />
                } 
              }
            }
          </div>
          }

          <div class="checkbox-container">
            <p-checkbox formControlName="agree" [binary]="true" size="small" inputId="input-agree" />
            <label for="input-agree" class="ml-2">
              Я даю согласие на обработку моих персональных данных. Подробнее об условиях обработки — в
              <a href="https://pvz-admin.ru/privacy.pdf" target="_blank">политике конфиденциальности</a>.
            </label>
          </div>

          @if (outroText()) {
          <p class="outro-text" [innerHTML]="outroText()"></p>
          }

          <div class="button-container">
            <pa-button [disabled]="form.invalid" [label]="'Отправить'" [severity]="'primary'" (click)="onSubmit()"> </pa-button>
          </div>
        </form>
      </div>
      } @if (isSubmitted()) {
      <div class="info-message-container">
        <div class="info-message">
          <div class="info-message-title">Анкета отправлена</div>
          <div class="info-message-text">Спасибо! Ваша анкета успешно отправлена. Ожидайте обратной связи от работодателя.</div>
        </div>
      </div>
      } @if (isNotAvailable()) {
        @if (isAuthorized()) {
          <div class="info-message-container">
            <div class="info-message">
              <div class="info-message-title">Анкета не опубликована</div>
              <div class="info-message-text">
                Анкета не опубликована. Попробуйте перейти по ссылке позже или уточните актуальность вакансии.
              </div>
            </div>
          </div>
        } @else {
          <div class="info-message-container">
            <div class="info-message">
              <div class="info-message-title">Вакансия недоступна</div>
              <div class="info-message-text">
                Вакансия временно недоступна, не найдена или была удалена. Попробуйте перейти по ссылке позже или уточните актуальность вакансии
                у работодателя.
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</ion-content>
